var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2222 4.77778H17.3333V3H15.5556V4.77778H8.44444V3H6.66667V4.77778H5.77778C4.79111 4.77778 4 5.57778 4 6.55556V19C4 19.9867 4.8 20.7778 5.77778 20.7778H18.2222C19.2089 20.7778 20 19.9867 20 19V6.55556C20 5.57778 19.2089 4.77778 18.2222 4.77778ZM18.2222 19H5.77778V10.1111H18.2222V19ZM18.2222 8.33333H5.77778V6.55556H18.2222V8.33333Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.99dd819b19688c63e4e73353dc983765.svg";
export { ForwardRef as ReactComponent };